import "./ContactFormBrandMark.css";

const LOGO_SRC = "/brand/logo-contact-vertical.png";

export default function ContactFormBrandMark({ variant = "aside" }) {
  return (
    <div
      className={`contact-form-brand-mark contact-form-brand-mark--${variant}`}
      aria-hidden="true"
    >
      <img src={LOGO_SRC} alt="" className="contact-form-brand-mark__img" />
    </div>
  );
}
